import queryString from 'query-string'

/**
 * Chuỗi query (có hoặc không có `?`) → params GET cho các API danh sách BanHang.
 * Map `createdById` → `nguoiTao` để tương thích màn chi tiết user.
 */
export const banHangListParamsFromQueryString = (search: string): Record<string, unknown> => {
  const trimmed = search.replace(/^\?/, '')
  const q = queryString.parse(trimmed, { parseNumbers: true, parseBooleans: true })
  const out: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null || v === '') continue
    if (Array.isArray(v)) {
      const cleaned = v.filter((x) => x !== undefined && x !== null && x !== '')
      if (cleaned.length === 0) continue
      out[k] = cleaned.length === 1 ? cleaned[0] : cleaned
    } else {
      out[k] = v
    }
  }
  if (out.nguoiTao == null && out.nguoiTaoId != null) {
    out.nguoiTao = out.nguoiTaoId
    delete out.nguoiTaoId
  }
  if (out.nguoiTao == null && out.createdById != null) {
    out.nguoiTao = out.createdById
    delete out.createdById
  }
  if (out.bangGia == null && out.bangGiaId != null) {
    out.bangGia = out.bangGiaId
    delete out.bangGiaId
  }
  if (out.nguoiBan == null && out.nguoiBanId != null) {
    out.nguoiBan = out.nguoiBanId
    delete out.nguoiBanId
  }
  if (out.nguoiNhanDat == null && out.nguoiNhanDatId != null) {
    out.nguoiNhanDat = out.nguoiNhanDatId
    delete out.nguoiNhanDatId
  }

  const toPositiveIntIds = (raw: unknown): number[] => {
    if (raw == null || raw === '') return []
    const arr = Array.isArray(raw) ? raw : String(raw).split(/[,;|]/)
    const ids = arr
      .map((item) => Number(typeof item === 'string' ? item.trim() : item))
      .filter((n) => Number.isInteger(n) && n > 0)
    return Array.from(new Set(ids))
  }
  const branchIds = [
    ...toPositiveIntIds(out.chiNhanhIds),
    ...toPositiveIntIds(out.chiNhanhId),
  ]
  delete out.chiNhanhId
  delete out.chiNhanhIds
  if (branchIds.length === 1) out.chiNhanhId = branchIds[0]
  else if (branchIds.length > 1) out.chiNhanhIds = branchIds

  return out
}
